import { absolutePath } from "./absolutePath";

export const communityLead = {
  delete: ({ leadUid }: { leadUid: string }) =>
    absolutePath(`community_leads/${leadUid}/`),
};
